export default function isInHttps()
{
    return window.location.href.startsWith('https');
}
